/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/Tasks/Loading"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<div
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-2mx3jB': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 borderBottomLeftRadius={10}
 borderBottomRightRadius={10}
 borderTopLeftRadius={10}
 borderTopRightRadius={10}
 height={16}
 width={320}
/>
</div>
{children}
</React.Fragment>)
}